import React, { useEffect, useMemo, useState } from "react";
import Moment from "moment-timezone";
import { css, select as $, media } from "glamor";

import Calendar from "../../calendar/Calendar2";
import InputField from "../../toolBox/InputField";
import HourPicker from "./HourPicker";

import { colors } from "../../../helpers/styles";

import { getDuration } from "../functions";
import { formatISOasAMPM } from "../../../helpers/functions";
import OutsideAlerter from "../../clickOutside/OutsideAlerter";


/*
THIS IS THE UPDATED VERSION FROM DATEPICKER.JSX
IT IS ONLY USED IN OUTLIERS FOR NOW... BUT MAY BE USED ELSEWHERE, INCLUDING LEAVE REQUESTS

IT NEEDS TO BE FURTHER REFACTORED AND TESTED, AND PROBABLY MOVED TO TOOLBOX
USE THIS COMPONENT GOING FORWARD, INSTEAD OF DATEPICKER.JSX
*/

const MobileDayPicker = ({ error, focus, label, value, setDate, type }) => {
  return (
    <div {...css({ float: "left", width: "100%" })}>
      <label
        {...css({
          fontSize: 14,
          lineHeight: "17px",
          fontWeight: 500,
          color: error
            ? colors.red
            : focus
              ? colors.blue
              : "rgba(0, 0, 0, 0.54)",
        })}
      >
        {label}
      </label>
      <div {...css({ position: "relative" })}>
        <input
          autoComplete="off"
          type={type}
          value={value}
          onChange={(e) => {
            setDate(e.target.value);
          }}
          {...css(
            {
              float: "left",
              border: 0,
              borderBottom: error
                ? `1px solid ${colors.red}`
                : "1px solid rgba(226, 226, 226, 1)",
              fontFamily: "Museo Sans",
              fontSize: 16,
              color: "#28AAFF",
              textShadow: "0px 0px 0px rgba(0, 0, 0, 0.87)",
              WebkitTextFillColor: "transparent",
              width: "100%",
              height: 33,
              fontWeight: 300,
              background: "white",
            },
            $("::-webkit-input-placeholder", {
              textShadow: "none",
              WebkitTextFillColor: "initial",
            }),
            $(":focus", {
              outline: 0,
              borderBottom: error
                ? `1px solid ${colors.red}`
                : `1px solid ${colors.blue}`,
            }),
            $(":disabled", {
              background: "white",
            })
          )}
        />
      </div>
    </div>
  );
};

const DayPickerOutside = ({
  selectDay,
  initialDate,
  calendarStyle,
  handleFocus,
}) => {
  return (
    <OutsideAlerter action={handleFocus}>
      <div
        {...css(
          {
            position: "absolute",
            width: 342,
            height: 302,
            background: "white",
            textAlign: "center",
            zIndex: 1,
            borderRadius: 5,
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
            padding: 8,
            boxSizing: "border-box",
            top: 56,
          },
          calendarStyle
        )}
      >
        <Calendar
          initialDate={new Date(initialDate)}
          specificDaysSelected={[new Date(initialDate)]}
          setSpecificDay={(date) => {
            selectDay(date);
          }}
        />
      </div>
    </OutsideAlerter>
  );
};

const CalenderPicker = DayPickerOutside;

class DayPicker extends React.Component {
  state = {
    picker: false,
  };
  render() {
    const {
      customStyle,
      label,
      value,
      setDate,
      error,
      disabled,
      calendarStyle,
    } = this.props;
    return (
      <div {...css(customStyle, { position: "relative" })}>
        <InputField
          label={label}
          value={value}
          noTyping={true}
          handleClick={() => this.setState({ picker: true })}
          error={error}
          disabled={disabled}
          externalFocus={this.state.picker}
          cursor="pointer"
        />
        {this.state.picker && (
          <CalenderPicker
            handleFocus={() => this.setState({ picker: false })}
            selectDay={(date, type) => {
              setDate(date, type);
              this.setState({ picker: false });
            }}
            initialDate={value}
            calendarStyle={calendarStyle}
          />
        )}
      </div>
    );
  }
}

function getNewDate(time, date, format12h) {
  let hours = 0;
  let minutes = 0;
  if (time && time.length > 4 && !format12h) {
    hours = time.slice(0, 2);
    minutes = time.slice(3, 5);
  } else {
    hours = Moment(time, "HH:mm a").format("HH");
    minutes = Moment(time, "HH:mm a").format("mm");
  }

  if (hours === "Invalid date" || minutes === "Invalid date") {
    return null;
  }

  return Moment(date).set({
    hours,
    minutes,
  });
}

export default function DatePicker(props: any) {
  const { allDay, startDate, endDate, setDate, disabled, timezone, format12h } =
    props;

  console.log("startDate", startDate.toISOString());
  console.log("endDate", endDate.toISOString());


  useEffect(() => {
    if (allDay) {
      const newStartDate = Moment(startDate).startOf("day");
      let newEndDate = Moment(endDate).startOf("day");
      if (Moment(newEndDate).isSameOrBefore(newStartDate)) {
        newEndDate = newEndDate.add(1, "day");
      }
      setDate(newStartDate, "startDate");
      setDate(newEndDate, "endDate");
    }
  }, [allDay, startDate, endDate, setDate]);

  const isValid = useMemo(() => {
    return (
      Moment(startDate).isValid() &&
      Moment(endDate).isValid() &&
      Moment(startDate).isBefore(Moment(endDate))
    );
  }, [startDate, endDate]);

  const metaBox = {
    float: "left",
    width: "100%",
    height: 20,
    lineHeight: "20px",
    fontSize: 14,
    fontWeight: 300,
  };

  const duration = Moment.duration(Moment(endDate).diff(startDate));
  const metaText = getMetaText(duration);

  return (
    <div>
      {allDay ? (
        <div {...css({ float: "left", width: "100%", marginBottom: 24 })}>
          <div {...css({ float: "left", width: "100%" })}>
            {/* mobile date picker*/}
            <div
              {...css(
                { display: "none" },
                media("(max-width: 500px)", {
                  display: "block",
                })
              )}
            >
              <div
                {...css({
                  float: "left",
                  width: "calc(50% - 6px)",
                  marginRight: 12,
                })}
              >
                <MobileDayPicker
                  error=""
                  focus=""
                  label="Start date"
                  value={Moment(startDate).format("YYYY-MM-DD")}
                  setDate={(date) => {
                    const newDate = Moment.tz(
                      Moment(date).format("DD-MM-YYYY, HH:mm"),
                      "DD-MM-YYYY, HH:mm",
                      timezone
                    );
                    setDate(newDate, "startDate");
                  }}
                  type="date"
                />
              </div>
              <div {...css({ float: "left", width: "calc(50% - 6px)" })}>
                <MobileDayPicker
                  error=""
                  focus=""
                  label="End date"
                  value={Moment(endDate)
                    .subtract(1, "day")
                    .format("YYYY-MM-DD")}
                  setDate={(date) => {
                    const newDate = Moment.tz(
                      Moment(date).add(1, "day").format("DD-MM-YYYY, HH:mm"),
                      "DD-MM-YYYY, HH:mm",
                      timezone
                    );
                    setDate(newDate, "endDate");
                  }}
                  type="date"
                />
              </div>
            </div>
            <div
              {...css(
                media("(max-width: 500px)", {
                  display: "none",
                })
              )}
            >
              <DayPicker
                label="Start date"
                customStyle={{
                  ...css(
                    {
                      float: "left",
                      width: "calc(50% - 8px)",
                      marginRight: 16,
                    },
                    media("(max-width: 500px)", {
                      width: "calc(50% - 6px)",
                      marginRight: 12,
                    })
                  ),
                }}
                value={Moment(startDate).format("dddd, D MMM YYYY")}
                setDate={(date) => {
                  const newDate = Moment.tz(
                    Moment(date).format("DD-MM-YYYY, HH:mm"),
                    "DD-MM-YYYY, HH:mm",
                    timezone
                  );
                  setDate(newDate, "startDate");
                }}
                error={!isValid}
                disabled={disabled}
                calendarStyle={{ left: 0 }}
              />{" "}
              <DayPicker
                label="End date"
                customStyle={{
                  ...css(
                    { float: "left", width: "calc(50% - 8px)" },
                    media("(max-width: 500px)", {
                      width: "calc(50% - 6px)",
                    })
                  ),
                }}
                value={Moment(endDate)
                  .subtract(1, "day")
                  .format("dddd, D MMM YYYY")}
                setDate={(date) => {
                  const newDate = Moment.tz(
                    Moment(date).add(1, "day").format("DD-MM-YYYY, HH:mm"),
                    "DD-MM-YYYY, HH:mm",
                    timezone
                  );
                  setDate(newDate, "endDate");
                }}
                error={!isValid}
                disabled={disabled}
                calendarStyle={{ right: 0 }}
              />
            </div>
          </div>
          <div {...css(metaBox)}>{metaText}</div>
        </div>
      ) : (
        <div {...css({ float: "left", width: "100%", marginBottom: 24 })}>
          <div
            {...css(
              { float: "left", width: "100%", display: "none" },
              media("(max-width: 500px)", {
                display: "block",
              })
            )}
          >
            <div
              {...css({
                float: "left",
                width: "100%",
                marginBottom: 24,
              })}
            >
              <MobileDayPicker
                error=""
                focus=""
                label="Start"
                value={startDate.format("YYYY-MM-DD[T]HH:mm")}
                setDate={(date) => {
                  const newDate = Moment.tz(
                    Moment(date).format("DD-MM-YYYY, HH:mm"),
                    "DD-MM-YYYY, HH:mm",
                    timezone
                  );
                  setDate(newDate, "startDate");
                }}
                type="datetime-local"
              />
            </div>
            <div
              {...css({
                float: "left",
                width: "100%",
              })}
            >
              <MobileDayPicker
                error=""
                focus=""
                label="End"
                value={endDate.format("YYYY-MM-DD[T]HH:mm")}
                setDate={(date) => {
                  const newDate = Moment.tz(
                    Moment(date).format("DD-MM-YYYY, HH:mm"),
                    "DD-MM-YYYY, HH:mm",
                    timezone
                  );
                  setDate(newDate, "endDate");
                }}
                type="datetime-local"
              />
            </div>
          </div>

          <DateAndTime
            dateLabel="Start date"
            hourLabel="Start time"
            date={startDate}
            duration={duration}
            disabled={disabled}
            setDate={(date) => {
              if (Moment(date).isSameOrAfter(endDate)) {
                setDate(Moment(date).add(1, "day"), "endDate");
              }
              setDate(date, "startDate");
            }}
            customStyle={{ marginBottom: 24 }}
            format12h={format12h}
            key={"start" + startDate.toISOString()}
          />
          <DateAndTime
            dateLabel="End date"
            hourLabel="End time"
            date={endDate}
            duration={duration}
            disabled={disabled}
            setDate={(date) => {
              if (Moment(date).isSameOrBefore(startDate)) {
                setDate(Moment(date).subtract(1, "day"), "startDate");
              }
              setDate(date, "endDate");
            }}
            format12h={format12h}
            key={"end" + endDate.toISOString()}
          />

          <div {...css(metaBox)}>{metaText}</div>
        </div>
      )}
    </div>
  );
}

function getMetaText(duration: Moment.Duration): string {
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days} day${days !== 1 ? "s" : ""}`);
  }

  if (hours > 0 || (days === 0 && minutes > 0)) {
    // If there are no days and some minutes, show partial hours as decimal
    if (days === 0 && minutes > 0 && hours === 0) {
      const decimalHours = +duration.asHours().toFixed(1); // Rounded to 1 decimal place
      parts.push(`${decimalHours} hour${decimalHours !== 1 ? "s" : ""}`);
      return parts.join(", ");
    } else {
      parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
    }
  }

  if (minutes > 0 && (days > 0 || hours > 0)) {
    parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
  } else if (minutes > 0 && hours === 0 && days === 0) {
    parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
  }

  return parts.join(", ");
}

function DateAndTime(props: any) {
  const [hours, setHours] = useState(
    props.format12h
      ? formatISOasAMPM(props.date)
      : Moment(props.date).format("HH:mm")
  );

  const {
    format12h,
    dateLabel,
    hourLabel,
    date,
    duration,
    disabled,
    customStyle,
  } = props;

  useEffect(() => {
    const date = getNewDate(hours, props.date, format12h);
    if (date) {
      props.setDate(date);
    } else {
      setHours(format12h ? "12:00am" : "00:00");
    }

    if (!hours) {
      setHours(format12h ? "12:00am" : "00:00");
    }
  }, [hours, props.format12h]);

  return (
    <div
      {...css(
        { float: "left", width: "100%" },
        customStyle,
        media("(max-width: 500px)", {
          display: "none",
        })
      )}
    >
      <DayPicker
        label={dateLabel}
        customStyle={{
          ...css(
            { float: "left", width: 192, marginRight: 16 },
            media("(max-width: 500px)", {
              width: 165,
              marginRight: 12,
            })
          ),
        }}
        duration={duration}
        value={Moment(date).format("dddd, D MMM YYYY")}
        setDate={(date) => {
          props.setDate(getNewDate(hours, date, format12h));
        }}
        disabled={disabled}
        calendarStyle={{ left: 0 }}
      />{" "}
      <div
        {...css(
          { float: "left", width: 88, marginRight: 16 },
          media("(max-width: 500px)", {
            width: 76,
            marginRight: 12,
          })
        )}
      >
        <HourPicker
          handleChange={(e) => setHours(e.target.value)}
          value={hours}
          label={hourLabel}
          disabled={disabled}
          format12h={format12h}
        />
      </div>
    </div>
  );
}

// class DateAndTime extends React.Component {
//   state = {
//     hours: this.props.format12h
//       ? formatISOasAMPM(this.props.date)
//       : Moment(this.props.date).format("HH:mm"),
//   };

//   componentDidUpdate(prevProps, prevState) {
//     if (prevState.hours !== this.state.hours) {
//       const date = getNewDate(
//         this.state.hours,
//         this.props.date,
//         this.props.format12h
//       );
//       if (date) {
//         this.props.setDate(date);
//       } else {
//         this.setState({ hours: this.props.format12h ? "12:00am" : "00:00" });
//       }
//     }
//     if (!this.state.hours) {
//       this.setState({ hours: this.props.format12h ? "12:00am" : "00:00" });
//     }
//   }

//   render() {
//     const {
//       format12h,
//       dateLabel,
//       hourLabel,
//       date,
//       duration,
//       disabled,
//       customStyle,
//     } = this.props;

//     return (
//       <div
//         {...css(
//           { float: "left", width: "100%" },
//           customStyle,
//           media("(max-width: 500px)", {
//             display: "none",
//           })
//         )}
//       >
//         <DayPicker
//           label={dateLabel}
//           customStyle={{
//             ...css(
//               { float: "left", width: 192, marginRight: 16 },
//               media("(max-width: 500px)", {
//                 width: 165,
//                 marginRight: 12,
//               })
//             ),
//           }}
//           duration={duration}
//           value={Moment(date).format("dddd, D MMM YYYY")}
//           setDate={(date) => {
//             this.props.setDate(
//               getNewDate(this.state.hours, date, this.props.format12h)
//             );
//           }}
//           disabled={disabled}
//           calendarStyle={{ left: 0 }}
//         />{" "}
//         <div
//           {...css(
//             { float: "left", width: 88, marginRight: 16 },
//             media("(max-width: 500px)", {
//               width: 76,
//               marginRight: 12,
//             })
//           )}
//         >
//           <HourPicker
//             handleChange={(e) => this.setState({ hours: e.target.value })}
//             value={this.state.hours}
//             label={hourLabel}
//             disabled={disabled}
//             format12h={format12h}
//           />
//         </div>
//       </div>
//     );
//   }
// }
